import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecentlyFilledLoansComponent } from './recently-filled-loans/recently-filled-loans.component';
import {InvestormenuModule} from '../../../investormenu/investormenu.module';
import {CommonSectionsModule} from '../../common/common-sections.module';
import {MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule} from '@angular/material';
import {IndianCurrencyFormatterModule} from '../../common/indian-currency-formatter/indian-currency-formatter.module';
import {InvestorCommonsRoutingModule} from './investor-commons.routing.module';



@NgModule({
  declarations: [RecentlyFilledLoansComponent],
    imports: [
        CommonModule,
        InvestorCommonsRoutingModule,
        InvestormenuModule,
        CommonSectionsModule,
        MatTableModule,
        IndianCurrencyFormatterModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatPaginatorModule
    ]
})
export class InvestorCommonsModule { }
